export const uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getRouteUrl = (
  conferenceId: string,
  activityId: string,
  page: string,
  toProfile?: boolean,
) => {
  const pathConference = `/conference/${conferenceId}`;
  const pathActivity = `/activity/${activityId}`;
  const pathProfile = '/manage-profile';

  // Manage-profile URLs (e.g. from a QR) survive the auth bounce by
  // getting rebuilt here as /welcome|sign-in|sign-up + conference + manage-profile,
  // or as the final /conference/:id/manage-profile once authed.
  if (toProfile && conferenceId) {
    return page + pathConference + pathProfile;
  }

  if (page && conferenceId && activityId) {
    return page + pathConference + pathActivity;
  } else if (conferenceId && activityId) {
    return pathConference + pathActivity;
  }

  if (conferenceId && page && !activityId) {
    return page + pathConference;
  }

  return page;
};
